/**
 * @generated SignedSource<<933f392b4d22fe6570a26acfcaf3c0a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HomeQuery$variables = {};
export type HomeQuery$data = {
  readonly cmsArticle: {
    readonly data: {
      readonly " $fragmentSpreads": FragmentRefs<"ArticleFragment">;
    } | null;
  } | null;
};
export type HomeQuery = {
  variables: HomeQuery$variables;
  response: HomeQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "id",
    "value": 19
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CMSUploadFileEntity",
    "kind": "LinkedField",
    "name": "data",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CMSUploadFile",
        "kind": "LinkedField",
        "name": "attributes",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "alternativeText",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v1/*: any*/)
    ],
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "CMSComponentSharedSvojstvaSekczii",
  "kind": "LinkedField",
  "name": "sectionProperties",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backgroundColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CMSUploadFileEntityResponse",
      "kind": "LinkedField",
      "name": "backgroundImage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CMSUploadFileEntity",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CMSUploadFile",
              "kind": "LinkedField",
              "name": "attributes",
              "plural": false,
              "selections": [
                (v2/*: any*/)
              ],
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentMaximumWidth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "topPadding",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bottomPadding",
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "storageKey": null
},
v6 = [
  (v4/*: any*/),
  (v1/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HomeQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "CMSArticleEntityResponse",
        "kind": "LinkedField",
        "name": "cmsArticle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CMSArticleEntity",
            "kind": "LinkedField",
            "name": "data",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ArticleFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "cmsArticle(id:19)"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "HomeQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "CMSArticleEntityResponse",
        "kind": "LinkedField",
        "name": "cmsArticle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CMSArticleEntity",
            "kind": "LinkedField",
            "name": "data",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CMSArticle",
                "kind": "LinkedField",
                "name": "attributes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CMSUploadFileEntityResponse",
                    "kind": "LinkedField",
                    "name": "cover",
                    "plural": false,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "publishedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "blocks",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ],
                        "type": "CMSComponentSharedRichText",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CMSComponentSharedDecoratedListItem",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CMSComponentSharedMedia",
                                "kind": "LinkedField",
                                "name": "image",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CMSUploadFileEntityResponse",
                                    "kind": "LinkedField",
                                    "name": "file",
                                    "plural": false,
                                    "selections": (v3/*: any*/),
                                    "storageKey": null
                                  },
                                  (v1/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CMSComponentSharedRichText",
                                "kind": "LinkedField",
                                "name": "primaryText",
                                "plural": false,
                                "selections": (v6/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CMSComponentSharedRichText",
                                "kind": "LinkedField",
                                "name": "secondaryText",
                                "plural": false,
                                "selections": (v6/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "type": "CMSComponentSharedDecoratedList",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v5/*: any*/)
                        ],
                        "type": "CMSComponentSharedShowMore",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rotate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "interval",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CMSComponentElementsKarusel",
                            "kind": "LinkedField",
                            "name": "carouselItems",
                            "plural": true,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CMSUploadFileEntityResponse",
                                "kind": "LinkedField",
                                "name": "image",
                                "plural": false,
                                "selections": (v3/*: any*/),
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "type": "CMSComponentSharedKarusel",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rootCategory",
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "type": "CMSComponentSharedMagazinKatalog",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "categorySlug",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "numProducts",
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "type": "CMSComponentSharedMagazinTovary",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CMSComponentLinksButtonLink",
                            "kind": "LinkedField",
                            "name": "buttons",
                            "plural": true,
                            "selections": [
                              (v1/*: any*/),
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "text",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "type",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "newTab",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "type": "CMSComponentSharedButtonBar",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "cmsArticle(id:19)"
      }
    ]
  },
  "params": {
    "cacheID": "5a177bda1361a131c6c0ba1ecd682e64",
    "id": null,
    "metadata": {},
    "name": "HomeQuery",
    "operationKind": "query",
    "text": "query HomeQuery {\n  cmsArticle(id: 19) {\n    data {\n      ...ArticleFragment\n      id\n    }\n  }\n}\n\nfragment ArticleFragment on CMSArticleEntity {\n  id\n  attributes {\n    slug\n    title\n    description\n    cover {\n      data {\n        attributes {\n          url\n          alternativeText\n        }\n        id\n      }\n    }\n    publishedAt\n    blocks {\n      __typename\n      ... on CMSComponentSharedRichText {\n        id\n        body\n        sectionProperties {\n          backgroundColor\n          backgroundImage {\n            data {\n              attributes {\n                url\n              }\n              id\n            }\n          }\n          contentMaximumWidth\n          topPadding\n          bottomPadding\n          id\n        }\n      }\n      ... on CMSComponentSharedDecoratedList {\n        id\n        items {\n          id\n          image {\n            file {\n              data {\n                attributes {\n                  url\n                  alternativeText\n                }\n                id\n              }\n            }\n            id\n          }\n          primaryText {\n            body\n            id\n          }\n          secondaryText {\n            body\n            id\n          }\n        }\n        sectionProperties {\n          backgroundColor\n          backgroundImage {\n            data {\n              attributes {\n                url\n              }\n              id\n            }\n          }\n          contentMaximumWidth\n          topPadding\n          bottomPadding\n          id\n        }\n      }\n      ... on CMSComponentSharedShowMore {\n        id\n        sectionProperties {\n          backgroundColor\n          backgroundImage {\n            data {\n              attributes {\n                url\n              }\n              id\n            }\n          }\n          contentMaximumWidth\n          topPadding\n          bottomPadding\n          id\n        }\n      }\n      ... on CMSComponentSharedKarusel {\n        id\n        rotate\n        interval\n        carouselItems {\n          id\n          image {\n            data {\n              attributes {\n                url\n                alternativeText\n              }\n              id\n            }\n          }\n          body\n        }\n        sectionProperties {\n          backgroundColor\n          backgroundImage {\n            data {\n              attributes {\n                url\n              }\n              id\n            }\n          }\n          contentMaximumWidth\n          topPadding\n          bottomPadding\n          id\n        }\n      }\n      ... on CMSComponentSharedMagazinKatalog {\n        id\n        rootCategory\n        sectionProperties {\n          backgroundColor\n          backgroundImage {\n            data {\n              attributes {\n                url\n              }\n              id\n            }\n          }\n          contentMaximumWidth\n          topPadding\n          bottomPadding\n          id\n        }\n      }\n      ... on CMSComponentSharedMagazinTovary {\n        id\n        categorySlug\n        numProducts\n        sectionProperties {\n          backgroundColor\n          backgroundImage {\n            data {\n              attributes {\n                url\n              }\n              id\n            }\n          }\n          contentMaximumWidth\n          topPadding\n          bottomPadding\n          id\n        }\n      }\n      ... on CMSComponentSharedButtonBar {\n        id\n        buttons {\n          id\n          url\n          text\n          type\n          newTab\n        }\n        sectionProperties {\n          backgroundColor\n          backgroundImage {\n            data {\n              attributes {\n                url\n              }\n              id\n            }\n          }\n          contentMaximumWidth\n          topPadding\n          bottomPadding\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8074dd0bda3a2929cad38688b4aac5fb";

export default node;
